import { render, staticRenderFns } from "./CategoryDetails.vue?vue&type=template&id=7d1130ee&"
import script from "./CategoryDetails.vue?vue&type=script&lang=js&"
export * from "./CategoryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports